import { useQuery, UseQueryResult } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

const useGetFacebookConversions = (
    identifier: string,
): UseQueryResult<ApiResponse<any>, ApiError<null>> => {
    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<any>, ApiError<null>>(
        [`facebook-conversion_${queryKey}`],
        () => dataFetch.get(`${CORE_API_SUFFIX}organization-settings/facebook-conversion`),
    );
};

export default useGetFacebookConversions;
